import React, { useEffect, useState, useContext } from "react";
import useSWR, { useSWRConfig } from "swr";
import { useLocation, Redirect, useParams, useHistory } from "react-router-dom";
import QboxmailApi from "@/qboxmailApi";
import Stepper from "Components/stepper3/Stepper";
import useSteps from "Utils/useSteps";
import useFormState from "Utils/useFormState";
import useDeliveryPrices from "Utils/useDeliveryPrices";
import ExtraMessages from "./update_form/ExtraMessages";
import Plan from "./add_form/Plan";
import Recap from "./update_form/Recap";
import Loader from "Components/loader/Loader";
import ExtradeliveryRecap from "./update_form/ExtradeliveryRecap";
import PaymentMethod from "./add_form/PaymentMethod";
import { AuthContext } from "@/App";
import { deliveryPlans } from "@/config";

const api = new QboxmailApi({ useCookie: true });

const Update = (props) => {
  const { pathname } = useLocation();
  const { prices } = useDeliveryPrices();
  const isExtradelivery = pathname.includes("/extra-delivery");
  const isChangePlan = pathname.includes("/change-plan");
  const isEditPlanVolume = pathname.includes("/update/");
  const [selectedTier, setSelectedTier] = useState(null);

  const { getLoggedUser } = useContext(AuthContext);
  const loggedUser = getLoggedUser();
  const isManager = loggedUser.type === "Manager";
  const isReseller = loggedUser.is_reseller;

  const { accountCode } = useParams();

  const { data, error } = useSWR("/delivery/accounts/" + accountCode);
  const { data: limits } = useSWR(`/users/delivery_limits`);

  const { data: userBillingInfo } = useSWR(`/users/billing`, null, {
    revalidateOnFocus: false,
  });

  const [accountData, setAccountData] = useState(null);
  const [canHaveFreeAccount, setCanHaveFreeAccount] = useState(true);
  const [hideFreeAccountPicker, setHideFreeAccountPicker] = useState(false);
  const [hidePrices, setHidePrices] = useState(false);

  useEffect(() => {
    if (!limits) return;
    setCanHaveFreeAccount(limits.can_create_free_account);
    setHideFreeAccountPicker(limits.hide_free_account_picker);
    setHidePrices(limits.hide_prices);
  }, [limits]);

  const formState = useFormState();

  useEffect(() => {
    if (!data) return;
    const account = data.resources[0];

    if (isExtradelivery) {
      formState.setInitialValues({ volume: 5 });
    } else {
      formState.setInitialValues({
        plan: account.plan === "free" ? deliveryPlans.MONTHLY : account.plan,
        type: account.type,
        volume: 0,
        payment_method: "stripe",
      });
    }

    setAccountData(account);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const history = useHistory();

  const getSteps = () => {
    if (!accountData) {
      return [];
    }

    if (isChangePlan) {
      if (formState.formData.plan === "free") {
        return [Plan, Recap];
      }

      return [Plan, PaymentMethod, Recap];
    }

    return accountData.plan === "free"
      ? [Plan, Recap]
      : [isExtradelivery ? ExtraMessages : Plan, isExtradelivery ? ExtradeliveryRecap : Recap];
  };

  const { step, ToRender, stepBack, nextStep, stepsCount, skipNextStep, setSteps } = useSteps(getSteps());

  //TODO: add account info to go back
  const backToDashboard = () => history.push(`/delivery/accounts/${accountCode}`);

  if (!accountData || error || !prices || !limits) {
    return (
      <div className="contentWrapper">
        <Loader />
      </div>
    );
  }

  if (isExtradelivery && accountData.plan === "free") {
    return <Redirect to={`/delivery/accounts/update/${accountCode}`} />;
  }

  return (
    <div className="contentWrapper">
      <ToRender
        {...props}
        api={api}
        hideFreeAccountPicker={hideFreeAccountPicker}
        hidePrices={hidePrices}
        onFormCancel={backToDashboard}
        limits={limits}
        skipNextStep={skipNextStep}
        prices={prices}
        hasBillingInfo={!!userBillingInfo}
        isEditPlanVolume={isEditPlanVolume}
        isChangePlan={isChangePlan}
        nextStep={nextStep}
        stepper={<Stepper className="max-w-[--form-page-width]" steps={stepsCount} active={step} goBack={stepBack} />}
        isReseller={isReseller}
        {...formState}
        loggedUser={loggedUser}
        isUpdating
        canHaveFreeAccount={canHaveFreeAccount}
        actualVolume={accountData.volume}
        setSelectedTier={setSelectedTier}
        selectedTier={selectedTier}
        isExtradelivery={isExtradelivery}
        accountData={accountData}
      />
    </div>
  );
};

export default Update;
